import { ElementRef, Component } from '@angular/core';
import { Platform, NavController, NavParams } from 'ionic-angular';

import { RichTextEditorProvider } from '../../providers/rich-text-editor';

declare var $: any;

@Component({
  selector: 'page-rich-text-editor',
  templateUrl: 'rich-text-editor.html',
})
export class RichTextEditorPage {
	isDom: boolean = false;

	constructor(
		public richTextEditorProvider: RichTextEditorProvider, 
		public platform: Platform, 
		public elementRef: ElementRef,
		public navCtrl: NavController, 
		public navParams: NavParams) {
	}

	ionViewDidLoad() {
		console.log('ionViewDidLoad RichTextEditorPage');
	}

	ionViewDidEnter(){
		this.platform.ready().then((readySource) => {
	        if(readySource=="dom"){
	        	this.isDom = true;
	        	this.setupRTE();
	        }
		})
	}	

	onInputChange(text){
		this.richTextEditorProvider.setText(text);
	}

	setupRTE(){
		let $textArea = $(this.elementRef.nativeElement).find(" textarea");

		$textArea.froalaEditor({
			inlineMode: false,
		  	height: 200,
		  	toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough',  
		  					'|', 
		  					'fontFamily', 'fontSize', 'color', 'inlineStyle', 'paragraphStyle', 
		  					'|', 
		  					'paragraphFormat',  'align', 'formatOL', 'formatUL', 'outdent', 
		  					'indent', 'quote', '-', 'insertLink', 'insertTable', 
		  					'|', 
		  					'specialCharacters', 'insertHR', 'selectAll', 'clearFormatting', 
		  					'|', 
		  					'undo', 'redo']
		});	

		$textArea.on('froalaEditor.contentChanged', (e, editor) => {
			this.richTextEditorProvider.setText(editor.html.get());

			console.log(editor.html.get())
		});				
	}

	pop(){
		this.navCtrl.pop();
	}
}



// WEBPACK FOOTER //
// ./src/pages/rich-text-editor/rich-text-editor.ts